<template>
    <div v-if="options && options.length" class="roteirizacao-custo-ciclo-filter mb-3">
        <v-select
            dense
            outlined
            hide-details
            :items="options"
            :value="value"
            item-text="text"
            item-value="value"
            :label="label || $t('routePlanning.sidebar.costCycleFilter')"
            @change="onChange"
        />
    </div>
</template>

<script>
export default {
    name: 'RoteirizacaoCustoCicloFilter',
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
    },
    methods: {
        onChange(next) {
            this.$emit('input', next);
            this.$emit('change', next);
        },
    },
};
</script>
